import { render, staticRenderFns } from "./Silder.vue?vue&type=template&id=16315063&"
import script from "./Silder.vue?vue&type=script&lang=js&"
export * from "./Silder.vue?vue&type=script&lang=js&"
import style0 from "./Silder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports